import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { initialState, recomposeInvoice } from './utils'

// ------------------------------------
// Constants
// ------------------------------------
export const INVOICE = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
    GET_PAY_LINK_REQUEST: null,
    GET_PAY_LINK_SUCCESS: null,
  },
  'INVOICE'
)

// ------------------------------------
// Actions
// ------------------------------------
export function getDetail(linkId, callback) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch,
        method: 'POST',
        body: { linkId },
        endpoint: 'cgs/customerFrontend/invoice/getByLinkId',
        requestAction: INVOICE.INIT_REQUEST,
        successAction: INVOICE.INIT_SUCCESS,
        success(result) {
          callback && callback(null, result)
        },
      })
    )
  }
}

export function getPayLink(invoiceOrderId, callback) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch,
        method: 'POST',
        body: { invoiceOrderId },
        endpoint: 'cgs/customerFrontend/invoice/pay',
        requestAction: INVOICE.GET_PAY_LINK_REQUEST,
        successAction: INVOICE.GET_PAY_LINK_SUCCESS,
        success(result) {
          callback && callback(null, result)
        },
      })
    )
  }
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [INVOICE.INIT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [INVOICE.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      invoice: recomposeInvoice(action.payload),
      isFetching: false,
    }),
  [INVOICE.GET_PAY_LINK_REQUEST]: (state, action) =>
    Object.assign({}, state, { payLink: { isFetching: true } }),
  [INVOICE.GET_PAY_LINK_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      payLink: { value: action.payload, isFetching: false },
    }),
}

// ------------------------------------
// Reducer
// ------------------------------------
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'routesInvoice',
    reducerMap: {
      routesInvoiceState: reducer,
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)],
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
